import {
  elaMobileApi,
  elaViewProxy,
  elaApiProxy,
  elaApiProxyBody,
} from './index';
// elaMobileApi : ela/
// elaViewProxy : proxy/ela/view/1.0/
// elaApiProxy : proxy/ela/api/1.0/
// elaApiProxyBody : proxyBody/ela/api/1.0/

/* [ 신청서 ] */
// 신청서전체메뉴 조회
function getMobileApplMenu(params) {
  return elaViewProxy.get('mobile/appl/menu', {params});
}

// 자주쓰는신청서메뉴 조회
function getMobileApplBookmarkMenu() {
  return elaViewProxy.get('mobile/appl/menu/bookmark');
}

// 신청서 근태 구분 메뉴 조회
function getMobileGntGubunMenu() {
  return elaViewProxy.get('mobile/appl/menu/gnt-gubun');
}

// 신청서 뷰어 취소신청 버튼 여부 조회
function getViewerCancelApplButton(params) {
  return elaViewProxy.get('mobile/viewer/cancel-appl-button', { params });
}

// 신청서 초기 데이터 조회
function getElaApplInfo(params) {
  return elaMobileApi.get('appl/info', { params });
}

// 모든(결재,참조,담당) 결재라인 조회
function getApplLine(params) {
  return elaApiProxy.get('line/all', { params });
}

// 신청서 결재 저장(상신)
function postApplApproval(params) {
  return elaApiProxyBody.post('appl/approval', params);
}

// 신청서 결재 저장(결재)
function postApplConfirm(params) {
  return elaApiProxyBody.post('appl/confirm', params);
}

// 신청서 결재 저장(반려)
function postApplReject(params) {
  return elaApiProxyBody.post('appl/reject', params);
}

// 신청서 회수-삭제
function postApplCancel(params) {
  return elaMobileApi.post('appl/cancel', params);
}

export {
  getMobileApplMenu,
  getMobileApplBookmarkMenu,
  getMobileGntGubunMenu,
  getViewerCancelApplButton,
  getElaApplInfo,
  getApplLine,
  postApplApproval,
  postApplConfirm,
  postApplReject,
  postApplCancel,
};
